import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { TransactionInfo } from '@raisenow/epik';
import { Subscription } from 'rxjs';
import {
  Integration,
  RaiseNowModalResult,
  RaiseNowModalService,
} from './raisenow-modal.service';

@Component({
  selector: 'next-raisenow-modal',
  templateUrl: './raisenow-modal.component.html',
  styleUrls: ['./raisenow-modal.component.scss'],
})
export class RaiseNowModalComponent implements OnDestroy {
  /**
   * Emits the RaiseNow payment result
   */
  @Output() paymentResult = new EventEmitter<RaiseNowModalResult>();

  /**
   * Emits when Modal is finished
   *
   * @description This includes a successful payment transaction has been made,
   * and the form can now be resetted.
   */
  @Output() finished = new EventEmitter<void>();

  /**
   * Emits when modal was closed
   *
   * @description This can be used to interrupt an ongoing payment-transaction,
   * and remove the modal from the window.
   */
  @Output() closed = new EventEmitter<void>();

  protected isEPPModalShown = false;
  protected isTamaroModalShown = false;

  /**
   * Container subscription
   */
  private readonly subscription = new Subscription();

  constructor(private raiseNowModalService: RaiseNowModalService) {
    this.subscription.add(
      this.raiseNowModalService.openEPPModal.subscribe((value) => {
        this.isEPPModalShown = value;
      }),
    );

    this.subscription.add(
      this.raiseNowModalService.openTamaro.subscribe((value) => {
        this.isTamaroModalShown = value;
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeEPPModal() {
    this.isEPPModalShown = false;
    this.raiseNowModalService.close();
    this.closed.emit();
  }

  closeTamaroModal() {
    this.isTamaroModalShown = false;
    this.raiseNowModalService.close();
    this.closed.emit();
  }

  showSuccessModalAndResetForm() {
    this.finished.emit();
  }

  onEppModalSuccess(transactionInfo: TransactionInfo) {
    this.paymentResult.emit({
      integration: Integration.Epik,
      transactionInfo,
    });
  }
}
